<template>
  <div class="mt90">
    <el-row class="pr-bgimg pr-bg-information1"></el-row>
    <el-row class="pr-container bg-white mt-160 pb-6">
      <h2 class="page-title">公司介绍</h2>
      <p class="page-sub-title">About us</p>
      <p class="text-center col666 px-5 line-h24">深圳市蒲睿科技有限公司（以下简称：蒲睿），通过创新技术服务帮助客户快速实现业务目标。<br/>蒲睿成立于2017年，总部位于深圳，目前业务范围主要覆盖华南地区，并积极拓展全国业务。蒲睿在过往的信息技术服务中，<br/>积累了丰富的实战技术资源、专业人才资源，并构建了成熟的过程实施于质量管控体系。在此基础上，蒲睿通过行业积累，形成了一系列行业解决方案，<br/>为金融、制造业、互联网提供专业解决方案及信息科技服务。蒲睿致力于以信息技术及专业服务助推客户的商业成功，取得共赢。</p>
      <div class="pt-5 px-5 clear mw-img100">
        <el-col class="mb-5">
          <h2 class="font26 f-w500 col333">发展历程</h2>
          <div class="text-center pt-4"><img src="../../assets/images/about/1.png" /></div>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.pr-bg-information1 {
  background-image: url('../../assets/images/about/1482133012275.jpg');
}
</style>

